( () => {
  /** Utilities */
  const isProcessed = ( el ) => el?.dataset.authorsProcessed === '1';
  const markProcessed = ( el ) => { el.dataset.authorsProcessed = '1'; };

  /** Move a single author's avatar and name into the target boxes, with a leading separator */
  const appendAuthorIntoFirst = ( author, avatarBox, contentBox, addSeparator ) => {
    if ( !author || !contentBox ) return;

    if ( addSeparator ) {
      // Create a comma + non-breaking space separator: ", "
      const sep = document.createElement( 'span' );
      sep.appendChild( document.createTextNode( ',' ) ); // literal comma
      sep.appendChild( document.createTextNode( '\u00A0' ) ); // non-breaking space
      contentBox.appendChild( sep );
    }

    const img = author.querySelector( 'img' );
    if ( img && avatarBox ) avatarBox.appendChild( img );

    const name = author.querySelector( '.post-author__name' );
    if ( name ) {
      // Preserve the innerHTML to keep any links or other HTML elements
      const nameContent = name.innerHTML.trim();
      name.innerHTML = nameContent;
      contentBox.appendChild( name );
    }

    author.remove();
  };

  /** Merge all authors into the first .post-author */
  const mergeAuthors = ( container ) => {
    const authors = Array.from( container.querySelectorAll( '.post-author' ) );
    if ( authors.length <= 1 ) return;

    const [first, ...rest] = authors;
    const avatarBox = first.querySelector( '.post-author__avatar' );
    const contentBox = first.querySelector( '.post-author__content' );

    rest.forEach( ( author ) => {
      appendAuthorIntoFirst( author, avatarBox, contentBox, true );
    } );

    cleanContent( contentBox );
  };

  /** Remove whitespace, empty text nodes, and <br> tags from the content box */
  const cleanContent = ( contentBox ) => {
    if ( !contentBox ) return;
    [...contentBox.childNodes].forEach( ( node ) => {
      if (
        ( node.nodeType === Node.TEXT_NODE && !node.textContent.trim() ) ||
        ( node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR' )
      ) {
        node.remove();
      }
    } );
  };

  /** Move post date and reading time into the first author's content box (once) */
  const moveDateIntoAuthor = ( container ) => {
    const contentBox = container.querySelector( '.post-author__content' );
    if ( !contentBox ) return;

    const dateEl = container.parentElement?.querySelector( '.wp-block-post-date' );
    const readingTimeEl = container.parentElement?.querySelector( '.e-mtf--post-reading-time' );

    // If both date and reading time exist, wrap them in a div
    if ( dateEl && readingTimeEl && !contentBox.contains( dateEl ) && !contentBox.contains( readingTimeEl ) ) {
      const wrapperDiv = document.createElement( 'div' );
      wrapperDiv.className = 'post-meta-wrapper';
      
      wrapperDiv.appendChild( dateEl );
      wrapperDiv.appendChild( readingTimeEl );
      contentBox.appendChild( wrapperDiv );
    } else {
      // Add them individually if only one exists or they're already added
      if ( dateEl && !contentBox.contains( dateEl ) ) {
        contentBox.appendChild( dateEl );
      }
      
      if ( readingTimeEl && !contentBox.contains( readingTimeEl ) ) {
        contentBox.appendChild( readingTimeEl );
      }
    }

    cleanContent( contentBox );
  };

  /** Process a single container once */
  const processAuthorContainer = ( container ) => {
    if ( !container || isProcessed( container ) ) return;
    mergeAuthors( container );
    moveDateIntoAuthor( container );
    markProcessed( container );
  };

  /** Process all containers in a root (idempotent) */
  const processAll = ( root ) => {
    const ctx = root && ( root.nodeType === 1 || root.nodeType === 9 ) ? root : document;
    ctx.querySelectorAll( '.e-mtf--author-for-post, .e-div--resource-inner-author-wrapper' )
      .forEach( processAuthorContainer );
  };

  /** Boot + FacetWP hook (wrap to avoid passing Event object) */
  document.addEventListener( 'DOMContentLoaded', () => processAll() );
  document.addEventListener( 'facetwp-loaded', () => processAll() );
} )();
